import { DocumentAttributes, DocumentSubjectType } from '@/types'
import { CreateDocumentMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Selector as DocumentTypeSelector } from './document_type/selector'
import { Input } from '../base/input'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
  defaultValues: Partial<DocumentAttributes>
}

export const Form = ({ onSuccess, defaultValues }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    attributes,
    setAttributes,
    fieldErrors,
  } = useForm<CreateDocumentMutation, DocumentAttributes, never, never>({
    defaultValues: {
      documentTypeId: '',
      subjectType: DocumentSubjectType.Event,
      subjectId: '',
      number: undefined,
      reference: '',
      dateIssued: new Date,
      dateDue: null,
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createDocument',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <>
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildCustomField({
          name: 'Document type',
          field: 'documentTypeId',
          input: <DocumentTypeSelector
            invalid={!!fieldErrors?.documentTypeId}
            subject={attributes.subjectType}
            value={attributes.documentTypeId}
            onChange={value => setAttributes({ ...attributes, documentTypeId: value?.id || '' }) }
          />
        })}
        <div className="grid grid-cols-2 gap-6 items-center">
          { formBuilder.buildCustomField({
            name: 'Number',
            field: 'number',
            input: <Input
              invalid={!!fieldErrors?.number}
              placeholder="Leave blank for auto number"
              value={attributes.number || undefined}
              onChange={value => setAttributes({ ...attributes, number: parseInt(value.currentTarget.value || '0') }) }
            />
          })}
          { formBuilder.buildField({ name: 'Reference', field: 'reference', type: 'text' }) }
        </div>
        <div className="grid grid-cols-2 gap-6 items-center">
          { formBuilder.buildField({ name: 'Date issued', field: 'dateIssued', type: 'datetime' }) }
          { formBuilder.buildField({ name: 'Date due', field: 'dateDue', type: 'datetime' }) }
        </div>
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
